/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateVendorNoticeDto } from '../../models/create-vendor-notice-dto';
import { VendorNoticeDto } from '../../models/vendor-notice-dto';

export interface VendorNoticeControllerCreate$Params {

/**
 * 입점사 ID
 */
  id: string;
      body: CreateVendorNoticeDto
}

export function vendorNoticeControllerCreate(http: HttpClient, rootUrl: string, params: VendorNoticeControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorNoticeDto>> {
  const rb = new RequestBuilder(rootUrl, vendorNoticeControllerCreate.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorNoticeDto>;
    })
  );
}

vendorNoticeControllerCreate.PATH = '/api/vendor-notice/{id}';
